export interface Category {
  name: string;
  nameKey: string;
  url: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    nameKey: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20premium%20white%20leather%20sneakers%20floating%20at%20a%20slight%20angle%20against%20a%20soft%20sage%20green%20studio%20background%2C%20crisp%20product%20photography%2C%20gentle%20soft%20shadows%2C%20high-end%20footwear%20catalog%20style%2C%20minimalist%20clean%20composition&width=400&height=400&seq=cat-shoes-v2&orientation=squarish',
  },
  {
    name: 'Hoodies/Sweaters',
    nameKey: 'hoodiesSweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20stack%20of%20cozy%20pastel%20knit%20hoodies%20and%20chunky%20sweaters%20on%20a%20light%20lavender%20studio%20backdrop%2C%20soft%20diffused%20lighting%2C%20editorial%20textile%20photography%2C%20plush%20fabric%20texture%20detail%2C%20calm%20minimal%20styling&width=400&height=400&seq=cat-hoodies-v2&orientation=squarish',
  },
  {
    name: 'T-Shirts',
    nameKey: 'tShirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20folded%20cotton%20t-shirts%20in%20coral%2C%20mustard%20and%20dusty%20blue%20arranged%20in%20a%20fan%20on%20a%20warm%20sand%20colored%20surface%2C%20bright%20airy%20product%20photography%2C%20soft%20natural%20window%20light%2C%20casual%20streetwear%20catalog%20aesthetic&width=400&height=400&seq=cat-tshirts-v2&orientation=squarish',
  },
  {
    name: 'Jackets',
    nameKey: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20brown%20leather%20bomber%20jacket%20and%20a%20navy%20denim%20jacket%20hanging%20side%20by%20side%20on%20a%20wooden%20rack%20against%20a%20light%20terracotta%20wall%2C%20warm%20editorial%20styling%2C%20soft%20directional%20lighting%2C%20premium%20outerwear%20catalog%20photography&width=400&height=400&seq=cat-jackets-v2&orientation=squarish',
  },
  {
    name: 'Pants/Shorts',
    nameKey: 'pantsShorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Folded%20indigo%20jeans%2C%20khaki%20chinos%20and%20olive%20cargo%20shorts%20stacked%20in%20a%20tidy%20column%20on%20a%20pale%20blue%20gray%20studio%20backdrop%2C%20clean%20denim%20fabric%20texture%2C%20soft%20even%20lighting%2C%20menswear%20catalog%20photography&width=400&height=400&seq=cat-pants-v2&orientation=squarish',
  },
  {
    name: 'Headwear',
    nameKey: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20baseball%20caps%2C%20beanies%20and%20a%20bucket%20hat%20in%20earthy%20tones%20arranged%20on%20a%20warm%20off-white%20linen%20cloth%2C%20soft%20morning%20light%2C%20laid-back%20streetwear%20editorial%2C%20premium%20headwear%20product%20photography&width=400&height=400&seq=cat-headwear-v2&orientation=squarish',
  },
  {
    name: 'Sets',
    nameKey: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20coordinated%20matching%20tracksuit%20set%20in%20soft%20grey%20and%20cream%20displayed%20flat%20on%20a%20muted%20blush%20pink%20background%2C%20neat%20symmetrical%20styling%2C%20soft%20studio%20lighting%2C%20athletic%20streetwear%20catalog%20aesthetic%2C%20clean%20composition&width=400&height=400&seq=cat-sets-v2&orientation=squarish',
  },
  {
    name: 'Underwear/Underpants',
    nameKey: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20premium%20cotton%20boxer%20briefs%20and%20undershirts%20in%20white%2C%20black%20and%20grey%20tones%20on%20a%20light%20mint%20green%20studio%20surface%2C%20minimal%20essentials%20photography%2C%20soft%20diffused%20light%2C%20clean%20comfortable%20apparel%20catalog&width=400&height=400&seq=cat-underwear-v2&orientation=squarish',
  },
  {
    name: 'Jersey',
    nameKey: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20vivid%20sports%20jersey%20with%20breathable%20mesh%20fabric%20and%20number%20print%20laid%20flat%20on%20a%20bright%20sky%20blue%20backdrop%2C%20energetic%20athletic%20photography%2C%20crisp%20studio%20lighting%2C%20performance%20sportswear%20catalog%20detail&width=400&height=400&seq=cat-jersey-v2&orientation=squarish',
  },
  {
    name: 'Accessories',
    nameKey: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20sunglasses%2C%20a%20minimalist%20wrist%20watch%20and%20a%20thin%20chain%20necklace%20arranged%20on%20a%20light%20stone%20grey%20podium%2C%20luxury%20accessories%20still%20life%2C%20soft%20reflective%20lighting%2C%20high-end%20editorial%20product%20photography&width=400&height=400&seq=cat-accessories-v2&orientation=squarish',
  },
  {
    name: 'Bags',
    nameKey: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20structured%20tan%20leather%20handbag%20and%20a%20charcoal%20canvas%20backpack%20placed%20on%20a%20warm%20ivory%20studio%20surface%2C%20premium%20bag%20photography%2C%20soft%20natural%20lighting%2C%20detailed%20leather%20texture%2C%20modern%20accessory%20catalog&width=400&height=400&seq=cat-bags-v2&orientation=squarish',
  },
  {
    name: 'Belts',
    nameKey: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coiled%20leather%20belts%20in%20brown%20black%20and%20tan%20with%20polished%20metal%20buckles%20arranged%20on%20a%20light%20oak%20wood%20table%2C%20warm%20side%20lighting%2C%20premium%20menswear%20accessory%20photography%2C%20rich%20leather%20grain%20detail&width=400&height=400&seq=cat-belts-v2&orientation=squarish',
  },
  {
    name: 'Perfumes',
    nameKey: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20elegant%20glass%20perfume%20bottles%20in%20amber%20rose%20and%20clear%20tones%20grouped%20on%20a%20soft%20cream%20marble%20surface%2C%20luxury%20fragrance%20still%20life%2C%20gentle%20golden%20hour%20lighting%2C%20refined%20beauty%20product%20photography&width=400&height=400&seq=cat-perfumes-v2&orientation=squarish',
  },
  {
    name: 'Other Stuff',
    nameKey: 'otherStuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20eclectic%20curated%20flatlay%20of%20lifestyle%20gadgets%2C%20a%20small%20speaker%2C%20sunglasses%20and%20a%20keychain%20wallet%20on%20a%20light%20grey%20concrete%20background%2C%20modern%20minimal%20still%20life%2C%20soft%20diffused%20lighting%2C%20clean%20editorial%20composition&width=400&height=400&seq=cat-other-v2&orientation=squarish',
  },
];